import { Component, Input, OnInit } from '@angular/core';
import { CmsConfig } from '../../config/cms.config';
import { CmsComponentsFacade } from '@kion/data-access/data-access-cms-components';
import {
  BaseCmsComponent,
  CmsCategoryComponent,
  CmsComponent,
  CmsImageLinkComponent,
  LinkRef
} from '@kion/data-models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

interface Category {
  image: {url: string, altText: string, titleText?: string};
  linkRef: LinkRef;
}


@Component({
  selector: 'kion-cms-category-list',
  templateUrl: './category-list.component.html',
  styleUrls: ['./category-list.component.scss']
})
export class CategoryListComponent implements OnInit {

  @Input() component: CmsCategoryComponent;

  public lazyCategories$: Observable<Category[]>;

  private static getImageUrl(component: BaseCmsComponent): {url: string, altText: string, titleText?: string} {
    return {url: component.mediaNew?.url, altText: component.mediaNew?.altText || 'no alt text provided', titleText: component.mediaNew?.titleText};
  }

  private static cmsComponentToCategory(cmsComponent: CmsImageLinkComponent): Category {
    const linkRef = {
      linkName: cmsComponent.linkName,
      contentPageLabelOrId: cmsComponent.contentPageLabelOrId,
      categoryCode: cmsComponent.categoryCode,
      productCode: cmsComponent.productCode,
      external: cmsComponent.external,
      target: cmsComponent.target,
      url: cmsComponent.url
    };
    return {
      image: CategoryListComponent.getImageUrl(cmsComponent),
      linkRef: linkRef
    }
  }

  constructor(
    private cmsComponentsFacade: CmsComponentsFacade,
    private cmsConfig: CmsConfig,
  ) { }

  ngOnInit(): void {
    const links = this.component?.imageLinks?.split(' ') || [];
    this.cmsComponentsFacade.loadByIds(links, links.join('_'));

    this.lazyCategories$ = this.cmsComponentsFacade.all$.pipe(
      map(
        (cmsComponents: CmsComponent[]) => cmsComponents.filter(
          (cmsComponent: CmsComponent) => links.find(imageLink => imageLink === cmsComponent.uid) !== undefined
        ).sort(
          (a: CmsComponent,b: CmsComponent) => {
            const indexA = links.indexOf(a.uid);
            const indexB = links.indexOf(b.uid);
            return indexA < indexB ? -1 : 1;
          }
        ).map(
          (cmsComponent: CmsComponent) => CategoryListComponent.cmsComponentToCategory(cmsComponent as any)
        )
      )
    );
  }
}
